<template>
	<div>
		<div class="float-right">
			<a id="popover-target-download" class="btn btn-secondary btn-lg mr-2 mb-3" tabindex="0">
				<b-icon icon="download"></b-icon>
			</a>
			<b-popover target="popover-target-download" triggers="focus" placement="bottom" ref="popover">
				<template #title>{{ $t('download') }}</template>
				<b-button @click="downloadFormResponses('csv')" class="mr-1 mb-1">{{ $t('csv') }} ({{ $tc('n-max', 1000) }})</b-button>
				<b-button @click="downloadFormResponses('pdf')">{{ $t('pdf') }} ({{ $tc('n-max', 30) }})</b-button>
			</b-popover>
		</div>
		<h1>{{report.title?report.title:$t('report')}}</h1>

		<b-tabs pills v-model="currenttab">

			<b-tab :title="$t('review')" v-if="report.status==1">
				<b-card-text>
     				<div v-if="!report.id" class="alert alert-danger mt-3">{{ $t('nothing-to-report') }}</div>
     				<template v-if="report.id">
						<div class="form-group mt-3">
							<label>{{ $t('student') }}</label>
							<select class="form-control" v-model="nextselecteduser" @change="selectUser">
								<option value="">{{ $t('select-caps') }}</option>
								<option
									v-for="student in studentreports.students"
									:key="student.id"
									:value="student"
								>{{student.displayName}}</option>
							</select>
						</div>
						<div class="clearfix" v-if="selecteduser">
							<Avatar
								class="avatar d-inline-block align-top mr-4 mb-3 lg:mb-0"
								:userId="selecteduser.id"
							/>
							<div class="clearfix d-inline-block align-top">
								<h2 class="mb-0">
									{{selecteduser.displayName}}
								</h2>
							</div>
						</div>
						<b-tabs pills v-model="currentreporttab" v-if="selecteduser">
							<b-tab :title="$t('term-report')">
								<b-card-text>
									<div class="mt-3" v-html="reportHtml"></div>
									<div class="mt-3" v-if="loadingreportview">
										<div class="clearfix">
											<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
											<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
											<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
										</div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
									</div>
								</b-card-text>
							</b-tab>
							<b-tab v-if="$config.hasModule('clinical')" :title="$t('activity-report')">
								<b-card-text>
									<!--
									<a
										class="btn btn-outline-secondary btn-sm mt-3"
										:href="`/reports/activity/${selecteduser.id}?date_from=${this.report.inputs.date_from}&amp;date_to=${this.report.inputs.date_to}&specialty=${this.report.inputs.specialty}`"
										target="_blank"
									>
										{{$t('open-in-new-window')}}
									</a>
									-->
									<div class="mt-3" v-html="individualReportHtml"></div>
									<div class="mt-3" v-if="loadingreportview">
										<div class="clearfix">
											<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
											<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
											<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
										</div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
										<div class="skeleton midnight h32 mb-3"></div>
									</div>
								</b-card-text>
							</b-tab>
							<b-tab :title="$t('feedback')" lazy>
								<b-card-text>
									<div class="row">
										<div class="col-md-6" v-if="'feedback' in studentreportsrequested[selecteduser.id] && studentreportsrequested[selecteduser.id].feedback.length > 0">
											<div v-if="studentreportsrequested[selecteduser.id]" class="mt-3">
												<div class="form-group mt-3">
													<label class="h2">{{ $t('teacher-feedback') }}</label>
													<select class="form-control" v-model="selectedfeedback">
														<option value="">{{ $t('select-caps') }}</option>
														<option
															v-for="teacher in studentreportsrequested[selecteduser.id].feedback"
															v-bind:key="teacher.id"
															:value="teacher"
														>{{teacher.displayName}}</option>
													</select>
												</div>
												<div v-if="selectedfeedback">
													<div class="card mb-3">
														<div class="card-body">
															<div v-for="(page, pageIndex) in selectedfeedback.feedback.pages" :key="pageIndex">
																<FormGrid :page="page" viewAs="editall" :readonly="true" ></FormGrid>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="col-md-6">
											<h2 class="mt-3">{{ $t('final-report') }}</h2>
											<div v-if="studentreportsrequested[selecteduser.id]">
												<div class="card">
													<div class="card-body">
														<div v-for="(page, pageIndex) in studentreportsrequested[selecteduser.id].form.pages" :key="pageIndex">
															<FormGrid viewAs="signer" :page="page" ></FormGrid>
														</div>
													</div>
												</div>
												<div class="clearfix mt-3">
													<button class="btn btn-success mb-2 ml-2 float-right" @click="submitFormResponse()">{{ $t('save') }}</button>
												</div>
											</div>
										</div>
									</div>
								</b-card-text>
							</b-tab>
						</b-tabs>
     				</template>
				</b-card-text>
			</b-tab>

			<b-tab :title="$t('settings')">
				<b-card-text>

					<div class="alert alert-info mt-3" v-if="report.id && (report.status==2 || report.status==3)">{{ $t('preparing-your-report-please-wait') }}</div>

					<div class="row mt-3">
						<div class="col-md-12">
							<div class="form-group">
								<label>{{ $t('title') }}</label>
								<input
									type="text"
									class="form-control"
									v-model="report.title"
									:disabled="report.id"
								>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('course') }}</label>
								<select
									type="text"
									v-model="report.inputs.programme"
									class="form-control"
									:disabled="report.id"
									@change="checkTermDates"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="programme in programmes"
										v-bind:key="programme.Id"
										:value="programme.Id"
									>{{programme.Name}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('school-year') }}</label>
								<select
									type="text"
									v-model="report.inputs.schooltermsession"
									class="form-control"
									:disabled="report.id"
									@change="checkTermDates"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="schooltermsession in schooltermsessions"
										v-bind:key="schooltermsession.id"
										:value="schooltermsession.id"
									>{{schooltermsession.caption}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('year') }}</label>
								<select
									type="text"
									v-model="report.inputs.year"
									class="form-control"
									:disabled="report.id"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="year in years"
										v-bind:key="year.id"
										:value="year.id"
									>{{year.caption}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('term') }}</label>
								<select
									type="text"
									v-model="report.inputs.term"
									class="form-control"
									:disabled="report.id"
									@change="checkTermDates"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="schoolterm in schoolterms"
										v-bind:key="schoolterm.id"
										:value="schoolterm.id"
									>{{schoolterm.caption}}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('firm') }}</label>
								<select
									type="text"
									v-model="report.inputs.selected_student_firm"
									class="form-control"
									:disabled="report.id"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="(caption, key) in $config.getValue('firms')"
										v-bind:key="key"
										:value="key"
									>{{caption}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('group') }}</label>
								<select
									type="text"
									v-model="report.inputs.selected_student_group"
									class="form-control"
									:disabled="report.id"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="(caption, key) in $config.getValue('groups')"
										v-bind:key="key"
										:value="key"
									>{{caption}}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('from') }}</label>
								<input
									type="date"
									v-model="report.inputs.date_from"
									class="form-control"
									:disabled="report.id"
								>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('to') }}</label>
								<input
									type="date"
									v-model="report.inputs.date_to"
									class="form-control"
									:disabled="report.id"
								>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('session-type') }}</label>
								<select
									type="text"
									v-model="report.inputs.session_type"
									class="form-control"
									:disabled="report.id"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="participationType in this.$config.getValue('participationTypes')"
										v-bind:key="participationType.id"
										:value="participationType.id"
									>{{participationType.name}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>{{ $t('specialty') }}</label>
								<select
									type="text"
									v-model="report.inputs.specialty"
									class="form-control"
									:disabled="report.id"
								>
									<option value="">{{ $t('select-caps') }}</option>
									<option
										v-for="specialty in this.$config.getValue('specialties')"
										v-bind:key="specialty.id"
										:value="specialty.id"
									>{{specialty.name}}</option>
								</select>
							</div>
						</div>
					</div>
					<button v-if="!report.id" @click="previewReport" class="btn btn-secondary mr-2">{{ $t('preview') }}</button>
					<button v-if="!report.id" @click="saveReport" class="btn btn-primary">{{ $t('save') }}</button>

					<button v-if="report.id" @click="refreshReportData" class="btn btn-primary">{{ $t('refresh-report-data') }}</button>

				</b-card-text>
			</b-tab>

			<b-tab :title="$t('publication')" v-if="report.status==1 && $UserSession.hasPriv('SAVEDREPORT_EDIT')">
				<b-card-text>

					<template v-if="report.id">
						<h2 class="mt-3">{{$t('publication')}}</h2>
						<div class="row mt-3">
							<div class="col-md-12">
								<div class="form-group">
									<label>{{ $t('students') }}</label>
									<div class="clearfix">
										<div class="pseudo-input mb-4">
											<input
												type="search"
												class="input-bare w-full flex-1"
												:placeholder="$t('students')"
												v-if="!studentreports.students.length"
												@click="openStudentsModal"
											/>
											<span
												class="badge badge-secondary badge-sm mr-2 mb-2"
												v-for="(student, index) in studentreports.students"
												v-bind:key="index"
											>
												{{ student.displayName }}
												<a @click="removeStudent(student)"><b-icon icon="x"></b-icon></a>
											</span>
											<span
												class="badge badge-primary badge-sm mr-2 mb-2"
												v-if="studentreports.students.length"
												@click="openStudentsModal"
											>
												<b-icon icon="plus"></b-icon> {{ $t('add') }}
											</span>
										</div>
									</div>
									<!--
									<div class="clearfix">
										<template v-for="programme in $config.getValue('programmes')">
											<template v-if="!('programme' in report.inputs) || programme.Id == report.inputs.programme">
												<template v-for="year in parseInt(programme.CourseLengthYears) + 1">
													<button
													class="btn btn-info mr-2 mb-4"
													@click="addStudentsBy({programme: programme.Id, year: year.toString()})"
													v-if="!('year' in report.inputs) || year == report.inputs.year"
													:key="`${programme.Name}-${year}`"
													>
													{{ programme.Name }}
													<template v-if="year <= parseInt(programme.CourseLengthYears)">
														{{ $t("year") }} {{ year }}
													</template>
													<template v-else>{{ $t('graduated') }}</template>
													</button>
												</template>
											</template>
										</template>

										<button class="btn btn-info mr-2 mb-4" @click="addStudentsBy({isStudent: true})">{{ $tc("all-students", 1) }}</button>
									</div>
									-->
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="form-group">
									<label class="mb-0">{{ $t('feedback') }}</label>
									<p class="small mb-1">{{ $t('this-report-requires-feedback-from-the-following-teachers') }}</p>
									<div class="clearfix">
										<div class="pseudo-input mb-4">
											<input
												type="search"
												class="input-bare w-full flex-1"
												:placeholder="$t('teachers')"
												v-if="!studentreports.teachers.length"
												@click="openTeachersModal"
											/>
											<span
												class="badge badge-secondary badge-sm mr-2 mb-2"
												v-for="(teachers, index) in studentreports.teachers"
												v-bind:key="index"
											>
												{{ teachers.displayName }}
												<a @click="removeTeacher(teachers)"><b-icon icon="x"></b-icon></a>
											</span>
											<span
												class="badge badge-primary badge-sm mr-2 mb-2"
												v-if="studentreports.teachers.length"
												@click="openTeachersModal"
											>
												<b-icon icon="plus"></b-icon> {{ $t('add') }}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">
								<h3 class="mb-0">{{ $t('feedback') }}</h3>
								<p class="small mb-1">{{ $t('feedback-forms-will-be-issued-to-teachers-on-the-publication-date-below-must-be-completed-by-the-deadline') }}</p>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>{{ $t('feedback-form') }}</label>
									<select
										type="text"
										v-model="studentreports.feedbackform_id"
										class="form-control"
										:disabled="studentreportsrequested && studentreports.feedbackform_id"
									>
										<option value="">{{ $t('select-caps') }}</option>
										<option
											v-for="form in forms"
											v-bind:key="form.id"
											:value="form.id"
										>{{form.title}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>{{ $t('feedback-publication-date') }}</label>
									<input
										type="datetime-local"
										v-model="studentreports.feedbackpublicationdate"
										class="form-control"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>{{ $t('feedback-deadline') }}</label>
									<input
										type="datetime-local"
										v-model="studentreports.feedbackdeadline"
										class="form-control"
									>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<h3 class="mb-0">{{ $t('final-report') }}</h3>
								<p class="small mb-1">{{ $t('final-reports-will-be-issued-to-students-on-the-publication-date-below-must-be-accepted-by-students-by-the-deadline') }}</p>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>{{ $t('report-form') }}</label>
									<select
										type="text"
										v-model="studentreports.form_id"
										class="form-control"
										:disabled="studentreportsrequested && studentreports.form_id"
									>
										<option value="">{{ $t('select-caps') }}</option>
										<option
											v-for="form in forms"
											v-bind:key="form.id"
											:value="form.id"
										>{{form.title}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>{{ $t('report-publication-date') }}</label>
									<input
										type="datetime-local"
										v-model="studentreports.reportpublicationdate"
										class="form-control"
									>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>{{ $t('report-deadline') }}</label>
									<input
										type="datetime-local"
										v-model="studentreports.reportdeadline"
										class="form-control"
									>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<template v-if="showpublicationpicker || !studentreportsrequested">
									<button class="btn btn-primary mr-2" @click="saveStudentReports">{{ $t('add') }}</button>
								</template>
								<template v-else>
									<button class="btn btn-primary mr-2" @click="saveStudentReports">{{ $t('update') }}</button>
									<button @click="refreshReportData" class="btn btn-primary">{{ $t('refresh-report-data') }}</button>
								</template>
							</div>
						</div>
					</template>

				</b-card-text>
			</b-tab>

     		<b-tab :title="$t('quick-view')">
     			<b-card-text>
     				<div v-if="!report.id && !this.preview" class="alert alert-danger mt-3">{{ $t('nothing-to-report') }}</div>
					<template v-if="report.id || this.preview">
						<div class="form-group mt-3">
							<label>{{ $t('student') }}</label>
							<select class="form-control" v-model="nextselecteduser" @change="selectUser">
								<option value="">{{ $t('select-caps') }}</option>
								<option
									v-for="student in studentoptions"
									v-bind:key="student.id"
									:value="student"
								>{{student.displayName}}</option>
							</select>
						</div>

						<div v-html="reportHtml"></div>
						<div v-if="loadingreportview">
							<div class="clearfix">
								<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
								<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
								<div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
							</div>
							<div class="skeleton midnight h32 mb-3"></div>
							<div class="skeleton midnight h32 mb-3"></div>
							<div class="skeleton midnight h32 mb-3"></div>
							<div class="skeleton midnight h32 mb-3"></div>
							<div class="skeleton midnight h32 mb-3"></div>
						</div>
					</template>
     			</b-card-text>
     		</b-tab>
		</b-tabs>
	</div>
</template>

<script>

import FormGrid from "src/components/FormEditor/FormGrid";
import Avatar from "src/components/Avatar.vue";

export default {
	components: {
		FormGrid,
		Avatar
	},
	data() {
		return {
			currenttab: 0 ,
			currentreporttab: 0 ,
			showpublicationpicker: false,
			preview: false ,
			select_user: '',
			studentoptions: [] ,
			feedbackusers: [] ,
			report: {
				id: null ,
				title: '' ,
				type: "termreport" ,
				inputs: {
					programme: null,
					schooltermsession: null,
					year: null,
					term: null,
					date_from: null,
					date_to: null
				} ,
				status: 2 ,
				created: null
			},
			studentreportsrequested: null ,
			studentreports: {
				students: [] ,
				teachers: [] ,
				form_id: null ,
				reportdeadline: null ,
				reportpublicationdate: null ,
				feedbackform_id: null ,
				feedbackdeadline: null ,
				feedbackpublicationdate: null ,
			},
			forms: [],
			selecteduser: null,
			nextselecteduser: null,
			selectedfeedback: null,
			loadingreportview: false,
			reportHtml: '',
			individualReportHtml: '',
			autosavetimeout: null
		};
	},
	mounted() {
		this.getReport()
	},
	computed: {
		programmes: function(){
			return this.$config.getValue('programmes');
		},
		schooltermsessions: function(){
			var options = []
			var schooltermsessions = this.$config.getValue('schooltermsessions');
			for(var index in schooltermsessions){
				var item = schooltermsessions[index];
				if(item.programme_id == this.report.inputs.programme){
					options.push({
						id: item.schooltermsession_id  ,
						caption: item.schooltermsession_title
					});
				}
			};
			return options;
		},
		years: function(){
			var options = []
			if(this.report.inputs.programme in this.programmes){
				var max = this.programmes[this.report.inputs.programme].CourseLengthYears;
				for(var i=1; i<=max; i++){
					options.push({
						id: i ,
						caption: i
					});
				}
			}
			return options;
		},
		schoolterms: function(){
			var options = []
			var schoolterms = this.$config.getValue('schoolterms');
			for(var index in schoolterms){
				var item = schoolterms[index];
				if(item.programme_id == this.report.inputs.programme){
					if(item.schoolyear_id == this.report.inputs.year){
						options.push({
							id: item.schoolterm_id  ,
							caption: item.schoolterm_title
						});
					}
				}
			};
			return options;
		}
	},
	methods: {
		unableToOpenReport() {
			const self = this;
			this.$store.commit("openDialog" , {
				title: this.$t('oops'),
				content: this.$t('unable-to-open-report'),
				confirmCallBack: function(){
					self.$router.replace('/reports/saved/list');
				}
			});
		},
		unableToSaveReport() {
			this.$store.commit("openDialog" , {
				title: this.$t('oops'),
				content: this.$t('unable-to-save-report')
			});
		},
		reportSaved() {
			this.$store.commit("openDialog" , {
				title: this.$t('saved'),
				content: this.$t('report-saved')
			});
		},
		getReport() {
			if (this.$route.params.reportid) {
				this.$store.commit("showBlockingSpinner");
				this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/get`, {
					method: "post",
					data: {
						id: this.$route.params.reportid
					}
				})
				.then(json => {
					this.$store.commit("hideBlockingSpinner");
					if (json.status === "SUCCESS") {
						this.report = json.result;
						this.getStudents();
						this.getForms();
						this.listStudentReports();
						if(this.report.status==2 || this.report.status==3){
							var self=this;
							window.setTimeout(function(){ self.getReportStatus(); }, 3000);
						}
					this.$store.commit("hideBlockingSpinner");
					} else {
						this.unableToOpenReport();
						this.$log.error.call(this, "Could not fetch report");
					}
				})
				.catch(error => {
					this.$store.commit("hideBlockingSpinner");
					this.unableToOpenReport();
					this.$log.error.call(this, error);
				});
			}
		},
		getReportStatus() {
			if (this.$route.params.reportid) {
				this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/get`, {
					method: "post",
					data: {
						id: this.$route.params.reportid
					}
				})
				.then(json => {
					if (json.status === "SUCCESS") {
						this.report.status = json.result.status;
						if(this.report.status==2 || this.report.status==3){
							var self=this;
							window.setTimeout(function(){ self.getReportStatus(); }, 3000);
						}
					} else {
						this.unableToOpenReport();
						this.$log.error.call(this, "Could not fetch report");
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
				});
			}
		},
		refreshReportData() {
			if (this.$route.params.reportid) {
				this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/refreshreport`, {
					method: "post",
					data: {
						id: this.$route.params.reportid
					}
				})
				.then(json => {
					if (json.status === "SUCCESS") {
						this.currenttab = 0;
						this.report.status = 2;
						var self=this;
						window.setTimeout(function(){ self.getReportStatus(); }, 3000);
					} else {
						this.$log.error.call(this, "Could not refresh report");
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
				});
			}
		},
		checkTermDates() {
			if(this.report.inputs.programme && this.report.inputs.schooltermsession && this.report.inputs.term){
				this.$cfetch(`${this.$settings.APIBaseURL}/gettermdates`, {
					method: "post",
					data: {
						programme_id: this.report.inputs.programme ,
						schooltermsession_id: this.report.inputs.schooltermsession ,
						schoolterm_id: this.report.inputs.term
					}
				})
				.then(json => {
					if (json.status === "SUCCESS") {
						if(json.data.schooltermdaterange_start){
							this.report.inputs.date_from = this.$datetime.getDateFieldValueFromTimestamp(json.data.schooltermdaterange_start);
						}
						if(json.data.schooltermdaterange_end){
							this.report.inputs.date_to = this.$datetime.getDateFieldValueFromTimestamp(json.data.schooltermdaterange_end);
						}
					}
				})
				.catch(error => {
					this.$log.error.call(this, error);
				});
			}
		},
		getStudents() {
			this.studentoptions = [];
			this.$users.getStudents.call(this).then(students => {
				students.forEach(user => {
					var isvalidoption = true;
					if('programme' in this.report.inputs){
						if(this.report.inputs.programme != user.programme){
							isvalidoption = false;
						}
					}
					if('year' in this.report.inputs){
						if(this.report.inputs.year != user.year){
							isvalidoption = false;
						}
					}
					if('selected_student_firm' in this.report.inputs){
						if(this.report.inputs.selected_student_firm != user.firm){
							isvalidoption = false;
						}
					}
					if('selected_student_group' in this.report.inputs){
						if(this.report.inputs.selected_student_group != user.group){
							isvalidoption = false;
						}
					}
					if(isvalidoption){
						//this.$set(this.studentoptions , user.id , user);
						this.studentoptions.push(user);
					}
				});
			});
		},
		getForms() {
			this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/selectform`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.forms = json.forms;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		previewReport() {
			this.getStudents();
			this.preview = true;
			this.currenttab = 3;
		},
		saveReport() {
			this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/save`, {
				method: "post",
				data: {
					report: this.report
				}
			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status === "SUCCESS") {
					this.report.id = json.result.id;
					this.$route.params.reportid = json.result.id;
					this.reportSaved();
					this.getStudents();
					this.getForms();
					if(this.report.status==2 || this.report.status==3){
						var self=this;
						window.setTimeout(function(){ self.getReportStatus(); }, 3000);
					}
				} else {
					this.unableToSaveReport();
					this.$log.error.call(this, "Could not fetch treatment session");
				}
			})
			.catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.unableToSaveReport();
				this.$log.error.call(this, error);
			});

		},
		saveStudentReports() {
			var data = JSON.parse(JSON.stringify(this.studentreports));
			data.user_id = [];
			this.studentreports.students.forEach(student => {
				data.user_id.push(student.id);
			});
			delete data.students;
			data.feedbackuser_id = [];
			this.studentreports.teachers.forEach(teacher => {
				data.feedbackuser_id.push(teacher.id);
			});
			delete data.teachers;
			var fields = ['reportpublicationdate' , 'reportdeadline' , 'feedbackpublicationdate' , 'feedbackdeadline'];
			fields.forEach(field => {
				if(data[field]){
					data[field] = this.$datetime.getTimeStampFromDateTimeField(data[field]);
				}
			});
			data.savedreport_id = this.report.id;
			this.$store.commit("showBlockingSpinner");
			this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/userreports/save`, {
				method: "post",
				data
			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status === "SUCCESS") {
					this.reportSaved();
					this.listStudentReports();
					this.showpublicationpicker = false;
				} else {
					this.unableToSaveReport();
					this.$log.error.call(this, "Could not fetch treatment session");
				}
			})
			.catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.unableToSaveReport();
				this.$log.error.call(this, error);
			});

		},
		listStudentReports(){
			//this.teacherreportsrequested = [];
			this.studentreports.students = [];
			this.studentreports.teachers = [];
			var teachersadded = [];
			this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/userreports/liststudents`, {
				method: "post",
				data: {
					savedreport_id: this.report.id
				}
			})
			.then(json => {
				if (json.status === "SUCCESS") {
					this.loadingreportview = false;
					if(json.result){
						if(Object.keys(json.result).length){
							this.studentreportsrequested = json.result;
						}
						for (var id in json.result) {
							var prop = json.result[id];

							this.studentreports.students.push(prop);

							this.studentreports.form_id = prop.form_id;
							this.studentreports.feedbackform_id = prop.feedbackform_id;

							if(prop.reportdeadline){
								this.studentreports.reportdeadline = this.$datetime.getDateTimeFieldValueFromTimestamp(prop.reportdeadline);
							}
							if(prop.reportpublicationdate){
								this.studentreports.reportpublicationdate = this.$datetime.getDateTimeFieldValueFromTimestamp(prop.reportpublicationdate);
							}
							if(prop.feedbackdeadline){
								this.studentreports.feedbackdeadline = this.$datetime.getDateTimeFieldValueFromTimestamp(prop.feedbackdeadline);
							}
							if(prop.feedbackpublicationdate){
								this.studentreports.feedbackpublicationdate = this.$datetime.getDateTimeFieldValueFromTimestamp(prop.feedbackpublicationdate);
							}

							if('feedback' in prop){
								prop.feedback.forEach(teacher => {
									if(!teachersadded.includes(teacher.id)){
										if('id' in teacher && teacher.id){
											this.studentreports.teachers.push(teacher);
											//this.teacherreportsrequested.push(teacher);
											teachersadded.push(teacher.id);
										}
									}
								});
							}

							//break;
						}
					}
				} else {
					this.$log.error.call(this, "Could not fetch user report");
				}
			})
		},
		selectUser() {
			this.tryAutosave();
			this.selecteduser = this.nextselecteduser;
			this.reportHtml = null;
			this.loadingreportview = true;
			this.selectedfeedback = null;
			var data = {
				user_id: this.selecteduser.id
			}
			if(this.report.id){
				data.id = this.report.id;
			} else {
				data.inputs = this.report.inputs;
			}
			this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/getreporthtml`, {
				method: "post",
				data
			})
			.then(json => {
				if (json.status === "SUCCESS") {
					this.loadingreportview = false;
					if(json.result){
						this.reportHtml = json.result;
					} else {
						this.reportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
					}
				} else {
					this.$log.error.call(this, "Could not fetch user report");
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});

			data = {
				student_id: this.selecteduser.id,
				date_from: this.report.inputs.date_from,
				date_to: this.report.inputs.date_to,
				specialty: this.report.inputs.specialty
			};
			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/htmlreport/individual`, {
				cache: false,
				data
			})
			.then(json => {
				if (json.status === "SUCCESS") {
					this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
					if(json.html){
						this.individualReportHtml = json.html;
					} else {
						this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
					}
				} else {
					this.$log.error.call(this, "Could not fetch user report");
					this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
				this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
			});
		},
		addStudentsBy(filter) {

			for (const userId in this.studentoptions) {
				const user = this.studentoptions[userId];
				let add = true;
				for (let key in filter) {
					if (user[key] === undefined || user[key] != filter[key]) {
						add = false;
					}
				}
				if(add && !this.studentreports.students.some(
					student => student.id == user.id // don't add students that have already been added
				)) {
					this.studentreports.students.push(user);
				}
			}
		},
		openStudentsModal() {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t('select-students'),
				selectCallback: function(selection) {
					const isSelected = self.studentreports.students.find(
						(student, i) => {
							if(student.id === selection.id){
								self.$delete(self.studentreports.students, i);
								return true;
							}
						}
					);
					if (!isSelected) {
						self.studentreports.students.push(selection);
					}
				},
				selected: this.studentreports.students,
				data: this.studentoptions,
				captionKey: 'displayName',
				studentSearchFilters: true,
				selectAllBtn: true
			});
		},
		removeStudent(selection) {
			const self = this
			self.studentreports.students.find(
				(student, i) => {
					if(student.id === selection.id){
						self.$delete(self.studentreports.students, i);
						return true;
					}
				}
			);
			return false;
		},
		openTeachersModal() {
			const self = this;
			this.$users.getTeachers.call(this).then(teachers => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t('select-teachers'),
					selectCallback: function(selection) {
						const isSelected = self.studentreports.teachers.find(
							(student, i) => {
								if(student.id === selection.id){
									self.$delete(self.studentreports.teachers, i);
									return true;
								}
							}
						);
						if (!isSelected) {
							self.studentreports.teachers.push(selection);
						}
					},
					selected: this.studentreports.teachers,
					data: teachers,
					captionKey: 'displayName'
				});
			});
		},
		removeTeacher(selection) {
			const self = this
			self.studentreports.teachers.find(
				(student, i) => {
					if(student.id === selection.id){
						self.$delete(self.studentreports.teachers, i);
						return true;
					}
				}
			);
			return false;
		},
    	formSubmitFailed() {
			this.$store.commit("openDialog", {
				title: this.$t("oops"),
				content: this.$t("form-save-failed"),
				confirmCallBack: function() {
				}
			});

    	},
    	formSubmitSuccess() {
			this.$store.commit("openDialog", {
				title: this.$t("saved"),
				content: this.$t("form-saved"),
				confirmCallBack: function() {
				}
			});

    	},
    	tryAutosave() {
    		if(this.currentreporttab == 2){
    			var self = this;
    			if(self.studentreportsrequested && self.selecteduser && (self.selecteduser.id in self.studentreportsrequested)){
					var reportform = JSON.parse(JSON.stringify(self.studentreportsrequested[self.selecteduser.id]));
					this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/save`, {
						method: 'post',
						data: {
							formresponse: {
  								id: reportform.formresponse_id ,
								formresponse_data: reportform.form
							}
						}
					})
					.then(json => {
						if (json.status.toLowerCase() === "success") {
							this.$log.info.call(this, 'Autosaved formresponse ' + json.formresponse.id);
						} else {
							self.formSubmitFailed();
						}
					}).catch(error => {
						this.$log.error.call(this, error);
					});
					/*
					Confirm dialog is too intrusive
					this.$store.commit("openDialog", {
						title: this.$t("save-report-question"),
						content: this.$t("save-your-recent-report-edits-question"),
						confirmCallBack: function() {
							this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/save/${reportform.formresponse_id}`, {
								method: 'post',
								data: {
									formresponse: {
										formresponse_data: reportform.form
									}
								}
							})
							.then(json => {
								if (json.status.toLowerCase() === "success") {
									this.$log.info.call(this, 'Autosaved formresponse ' + json.formresponse.id);
								} else {
									self.formSubmitFailed();
								}
							}).catch(error => {
								this.$log.error.call(this, error);
							});
						},
						cancelBtn: true,
						cancelCallBack: function() {
							//do nothing
						}
					});
					*/
				}
			}
    	},
    	submitFormResponse() {
    		this.$store.commit("showBlockingSpinner");
    		var reportform = JSON.parse(JSON.stringify(this.studentreportsrequested[this.selecteduser.id]));
  			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/save`, {
  				method: 'post',
  				data: {
  					formresponse: {
  						id: reportform.formresponse_id ,
  						formresponse_data: reportform.form
  					}
  				}
  			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status.toLowerCase() === "success") {
					// form saved
					//this.$router.replace(`/forms/list`);
					this.formSubmitSuccess();
				} else {
					// something went wrong
					this.formSubmitFailed();
				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.formSubmitFailed();
			});
    	},
		downloadFormResponses(format) {
			let body = {
				username: this.$UserSession.getValue.call(this, "username"),
				authToken: this.$UserSession.getValue.call(this, "authToken"),
				download: JSON.stringify({
					savedreport: this.$route.params.reportid,
					finalreport: true,
					format: format
				})
			};

			const url = `${this.$settings.APIBaseURL}/forms/response/list?` + new URLSearchParams(body).toString();
			//alert(url);
			window.open(url);

			//let routeData = this.$router.resolve({href: `${this.$settings.APIBaseURL}/forms/response/listall?`, query: body});
			//alert(routeData.href);
			//window.open(routeData.href, '_blank');
		}
	}
};
</script>
